import { Component, OnInit, HostListener, ElementRef, Input } from '@angular/core';
import { QuestionBase } from '../question-base';
import { ConfigurationsService } from 'core/services/configurations.service';
import { LocalesService } from 'core/services/locales.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'lms-dynamic-form-question-info',
  templateUrl: './dynamic-form-question-info.component.html',
  styleUrls: ['./dynamic-form-question-info.component.scss']
})
/**
 * Old Tooltip info in the labels for the forms
 */
export class DynamicFormQuestionInfoComponent implements OnInit {
  @Input() question: QuestionBase<any>;
  @Input() option: any;
  public visible = false;
  public loaded = false;
  public message: any = null;
  private tooltipMessagesSubscription: Subscription = new Subscription();

  constructor(
    private configurationsService: ConfigurationsService,
    private localesService: LocalesService,
    public elementRef: ElementRef
  ) {}

  ngOnInit() {
    if (this.option) {
      this.message = this.option.label;
    } else {
      this.message = this.question.label;
    }
  }

  onClick() {
    let key = this.question.action + '.';
    if (this.option) {
      key = key + this.option.key;
    } else {
      key = key + (this.question.tooltipKey || this.question.key);
    }

    if (!this.loaded) {
      this.tooltipMessagesSubscription = this.configurationsService
        .getInfoMessage$('toolTip', 'fields.keys[match]', key, 'textoDeAyuda', this.localesService.getBrowserLocale())
        .subscribe((message) => {
          if (message) {
            this.message = message;
          }
          this.loaded = true;
        });
    }
    this.visible = true;
  }

  @HostListener('document:click', ['$event'])
  hide(event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.visible = false;
    }
  }

  public ngOnDestroy(): void {
    this.tooltipMessagesSubscription.unsubscribe();
  }
}
